<template>
    <div>
        <div v-for="item in 100" :key="item">
            <div class="item">{{ item }}</div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'test',
    data() {
        return {
            list: []
        }
    },
    mounted() {
        // 确保页面滚动到顶部
        window.scrollTo(0, 0);
    },
    methods: {

    }
}
</script>
<style scoped>
.item {
    width: 200px;
    height: 200px;
    background-color: #f00;
    margin: 20px;
    color: aliceblue;
}
</style>


// WEBPACK FOOTER //
// src/views/test/index.vue